// @flow

import React, { useEffect } from 'react';
import ShowSnackMsg from './ShowSnackMsg';
import {Helmet} from 'react-helmet';
import theme from '../theme';
import {I18nProvider} from '../contexts/I18nContext';
import SquarePlanApp from './SquarePlanApp';

import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import store from '../reduxStore/index';

const App = () => {
  useEffect(() => {
    window.addEventListener('error', e => {
      if (/Loading chunk [\d]+ failed/.test(e.message)) {
        window.location.reload();
      }
    });
  }, []);

  return (
    <Provider store={store}>
      <I18nProvider>
        <ThemeProvider theme={theme}>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Neo Admin</title>
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" />
          </Helmet>
          <SquarePlanApp />
          <ShowSnackMsg />
        </ThemeProvider>
      </I18nProvider>
    </Provider>
  );
}
  
export default App;
